import { useRef } from "react";
import { Error } from "../errors/error";
import useHTTPProtoPost from "./useHTTPProtoPost";

// React hook to call the /auth/login endpoint to log in.
//
// The data passed to setRequest must be a LogInRequest proto. If the request
// completes successfully, a localStorage item for "is_authenticated" is set to
// true.
export default function useLogin(loginUrl) {
  const responseHandler = useRef(response => {
    if (response.ok) {
      localStorage.setItem("is_authenticated", "true");
      return;
    }

    return handleLoginError(response);
  });

  const [setRequest, { loading, error, called }] = useHTTPProtoPost(
    loginUrl,
    responseHandler.current
  );

  return [setRequest, { loading, error, called }];
}

// Attempts to unmarshal and throw the error from the login response. If this
// fails, a generic login error is thrown instead.
function handleLoginError(response) {
  return response.arrayBuffer().then(bodyStr => {
    let err = null;
    try {
      err = Error.fromProtoBinary(bodyStr);
    } catch {
      throw new Error({
        publicText: `Login failed with "${response.status} ${response.statusText}".`
      });
    }

    throw err;
  });
}
